import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  template: `
    <h2 mat-dialog-title>{{ 'PRIVACY_EXPLANATION_DIALOG.TITLE' | translate }}</h2>
    <mat-dialog-content class="dialog-content">
      <div> {{ 'PRIVACY_EXPLANATION_DIALOG.INTRO_SENTENCE' | translate }} </div>
      <ul>
        <li class="bullet-item" [innerHTML]="'PRIVACY_EXPLANATION_DIALOG.BULLET_ONE' | translate | iTrustThisHtml"></li>
        <li [innerHTML]="'PRIVACY_EXPLANATION_DIALOG.BULLET_TWO' | translate | iTrustThisHtml"></li>
      </ul>
      <div>{{ 'PRIVACY_EXPLANATION_DIALOG.OUTRO_SENTENCE' | translate }}</div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-flat-button color="primary" mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['privacy-explanation-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslateModule, GalaxyPipesModule],
})
export class PrivacyExplanationDialogComponent {}
